var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { class: _vm.classes, style: _vm.styles },
    [
      _vm.src
        ? _c("img", { attrs: { src: _vm.src }, on: { error: _vm.handleError } })
        : _vm.icon || _vm.customIcon
        ? _c("Icon", { attrs: { type: _vm.icon, custom: _vm.customIcon } })
        : _c(
            "span",
            {
              ref: "children",
              class: [_vm.prefixCls + "-string"],
              style: _vm.childrenStyle
            },
            [_vm._t("default")],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fdf9c25", { render: render, staticRenderFns: staticRenderFns })
  }
}